import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TemplatePreview from "../../components/TemplatePreview";
import { getFileMediaId, getMediaFromUrl } from "../../store/actions/globalAction";
import mime from "mime";
import { setSelectedTemplateMessage } from "../../utils/TemplateHelper";
import { sendLiveChatMessage } from "../../store/actions/tenantAction";
import { v4 as uuidv4 } from 'uuid';

function WhatsappMessage({ message, isReply = false, isReplied = false, reaction, selectedContact, isOpenWebLiveChat = false }) {
  const [previewfile, setPreviewfile] = useState();
  const [selectedButton, setSelectedButton] = useState();
  let dispatch = useDispatch();
  const [isDownLoading, setIsDownLoading] = useState(false);
  const [interactiveBtnShow, setInteractiveBtnShow] = useState(false);
  const interactiveBtn = useRef();
  const [carouselTemplate, setCarouselTemplate] = useState([]);
  const [template, setTemplate] = useState({
    templateType: "GENERIC",
    category: "MARKETING",
    language: "English",
    header: { type: "HEADER", format: "" },
    body: "",
    footer: "",
    buttons: [],
  });

  const globalReducer = useSelector((state) => state.globalReducer);
  const wabaTimezone =
    globalReducer.waba?.timezone ??
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        interactiveBtn.current &&
        !interactiveBtn.current.contains(event.target)
      ) {
        setInteractiveBtnShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!message) return;
    const msg = message?.messageText && Array.isArray(message.messageText)
      ? message.messageText[0]
      : message.messageText ?? {};
    switch (message?.type?.toLowerCase()) {
      case "template":
        onSelectTemplate(message?.template, message?.messageText);
        break;
      case "image":
        if (msg?.image?.link) {
          if (!msg?.image?.link?.startsWith("http")) {
            msg.image.link = `${process.env.REACT_APP_PRODUCT_APIURL}/storage/media/file?kay=${msg?.image?.link}`;
          }
          getMediaFromUrl(msg?.image?.link).then((fmd) => {
            setPreviewfile(fmd);
          });
        } else {
          getFileMediaId(
            globalReducer.waba?.tenantId,
            globalReducer.waba?.id,
            msg?.image?.id
          ).then((fmd) => {
            setPreviewfile(fmd);
          });
        }
        break;
      case "sticker":
        if (!msg?.sticker?.animated) {
          getFileMediaId(
            globalReducer.waba?.tenantId,
            globalReducer.waba?.id,
            msg?.sticker?.id
          ).then((fmd) => {
            setPreviewfile(fmd);
          });
        }
        break;
      case "interactive":
        if (msg?.interactive?.header?.type === "image") {
          if (msg?.interactive?.header?.image?.link) {
            if (!msg?.interactive?.header?.image?.link?.startsWith("http")) {
              msg.interactive.header.image.link = `${process.env.REACT_APP_PRODUCT_APIURL}/storage/media/file?kay=${msg?.interactive?.header?.image?.link}`;
            }
            getMediaFromUrl(msg?.interactive?.header?.image?.link).then((fmd) => {
              setPreviewfile(fmd);
            });
          } else if (msg?.interactive?.header?.image?.id) {
            getFileMediaId(
              globalReducer.waba?.tenantId,
              globalReducer.waba?.id,
              msg?.interactive?.header?.image?.id
            ).then((fmd) => {
              setPreviewfile(fmd);
            });
          }
        }
        break;
    }
  }, [message]);

  const onFileDownloading = (id) => {
    setIsDownLoading(true);
    getFileMediaId(
      globalReducer.waba?.tenantId,
      globalReducer.waba?.id,
      id
    ).then((fd) => {
      setPreviewfile(fd);
      setIsDownLoading(false);
    });
  };

  const onFileDownloadingFromUrl = (url) => {
    setIsDownLoading(true);
    if (!url?.startsWith("http")) {
      url = `${process.env.REACT_APP_PRODUCT_APIURL}/storage/media/file?kay=${url}`;
    }
    getMediaFromUrl(url).then((fmd) => {
      setPreviewfile(fmd);
      setIsDownLoading(false);
    });
  };

  const onFileDocumentDownloading = (id) => {
    setIsDownLoading(true);
    getFileMediaId(
      globalReducer.waba?.tenantId,
      globalReducer.waba?.id,
      id
    ).then((fd) => {
      saveBlobFile(
        fd,
        moment.utc(message?.createdAt).tz(wabaTimezone).format("YYYYMMMMDDhhmm")
      );
      setIsDownLoading(false);
    });
  };

  const onFileDocumentDownloadingFullUrl = (link) => {
    if (!link) return;
    if (!link?.startsWith("http")) {
      link = `${process.env.REACT_APP_PRODUCT_APIURL}/storage/media/file?kay=${link}`;
    }
    const a = document.createElement("a");
    a.href = link;
    a.target = "_blank"; // Set file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const saveBlobFile = (blobUrl, filename) => {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename; // Set file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl); // Clean up
  };

  const onSelectTemplate = (st, messageText) => {
    try {
      st.components = JSON.parse(st?.template ?? "[]");
      setSelectedTemplateMessage(
        st,
        messageText,
        setTemplate,
        setCarouselTemplate
      );
    } catch (e) {
      console.log(e);
    }
  };

  function latLngToTile(lat, lng, zoom) {
    const x = Math.floor(((lng + 180) / 360) * Math.pow(2, zoom));
    const y = Math.floor(
      ((1 -
        Math.log(
          Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)
        ) /
        Math.PI) /
        2) *
      Math.pow(2, zoom)
    );
    return `https://b.tile.openstreetmap.org/${zoom}/${x}/${y}.png`; //`http://b.tile.osm.org/${zoom}/${x}/${y}.png`;
  }
  const getExtension = (mimeType) => mime.getExtension(mimeType) || "Document";
  const getMessage = () => {
    if (!message) return null;
    const msg = message?.messageText && Array.isArray(message.messageText)
      ? message.messageText[0]
      : message.messageText ?? {};
    switch (message?.type?.toLowerCase()) {
      case "text":
        return (
          <div className="flex justify-between w-full">
            <p className="w-full h-auto sm:text-sm break-words whitespace-pre-wrap">
              {msg?.text?.body}
            </p>
          </div>
        );
      case "reaction":
        return (
          <div className="flex justify-between w-full">
            <p className="w-full h-auto sm:text-sm break-words whitespace-pre-wrap">
              {msg?.reaction?.emoji}
            </p>
          </div>
        );
      case "image":
        return (
          <div className="relative w-full">
            <div className="h-auto w-full mx-auto pb-5">
              <div className="h-[120px] min-w-[200px]">
                {previewfile ? (
                  <a href={previewfile} download>
                    <img
                      className={"h-full w-full object-contain rounded-md "}
                      src={previewfile}
                    />
                  </a>
                ) : (
                  <div className="flex justify-center pt-10">
                    <i className="fa-solid fa-image text-[24px] text-gray-400"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case "audio":
        return (
          <div className="w-full mx-auto">
            {previewfile ? (
              <audio
                key={previewfile}
                className="object-fill rounded-md min-w-[200px] w-full mx-auto pb-5"
                controls
              >
                <source src={previewfile} type={msg?.audio?.mime_type} />
              </audio>
            ) : (
              <div className="relative cursor-pointer h-[50px] w-full mx-auto">
                {isDownLoading && (
                  <div className="">
                    <div className="absolute pt-2 pl-5">
                      <div className="w-9 h-9 rounded-full animate-spin border-2 border-solid border-theme border-t-transparent" />
                    </div>
                  </div>
                )}
                <div
                  onClick={() => msg?.audio?.link ? onFileDownloadingFromUrl(msg?.audio?.link) : onFileDownloading(msg?.audio?.id)}
                  className="absolute bg-gray-500 bg-opacity-40 rounded-md h-[50px] w-full pl-5 pt-2 flex"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="text-white w-9 h-9"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <label className="ml-4 mt-1.5">Audio</label>
                </div>
              </div>
            )}
          </div>
        );
      case "video":
        return (
          <div className="w-full mx-auto h-[140px]">
            {previewfile ? (
              <video
                key={previewfile}
                className="object-fill rounded-md h-[140px] min-w-[200px] w-full mx-auto pb-5"
                controls
              >
                <source src={previewfile} type={msg?.video?.mime_type} />
              </video>
            ) : (
              <div className="relative cursor-pointer w-full mx-auto">
                {isDownLoading && (
                  <div className="flex justify-center item-center">
                    <div className="absolute pt-11">
                      <div className="w-9 h-9 rounded-full animate-spin border-2 border-solid border-theme border-t-transparent" />
                    </div>
                  </div>
                )}
                <div
                  onClick={() => msg?.video?.link ? onFileDownloadingFromUrl(msg?.video?.link) : onFileDownloading(msg?.video?.id)}
                  className="absolute bg-gray-500 bg-opacity-40 rounded-md h-[120px] w-full flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="text-white w-9 h-9"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        );
      case "sticker":
        return (
          <div className="relative w-full">
            <div className="h-auto w-full mx-auto pb-5">
              <div className="h-[120px] min-w-[200px]">
                {previewfile ? (
                  <a href={previewfile}>
                    <img
                      className={"h-full w-full object-contain rounded-md"}
                      src={previewfile}
                    />
                  </a>
                ) : (
                  <div className="flex justify-center pt-10">
                    <i className="fa-solid fa-image text-[24px] text-gray-400"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case "document":
        return (
          <div className="w-full mx-auto h-[140px]">
            <div
              className="w-full flex flex-col items-center rounded-md px-4 py-6"
              onClick={() => msg?.document?.id ? onFileDocumentDownloading(msg?.document?.id) : onFileDocumentDownloadingFullUrl(msg?.document?.link)}
            >
              {isDownLoading && (
                <div className="flex justify-center item-center">
                  <div className="absolute pt-11">
                    <div className="w-9 h-9 rounded-full animate-spin border-2 border-solid border-theme border-t-transparent" />
                  </div>
                </div>
              )}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                className="w-9 h-9 text-gray-400 hover:text-theme"
              >
                <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
              </svg>
              <div className="mt-2 w-full">
                <p className="text-xs text-center font-medium leading-5 text-gray-600">
                  {msg?.document?.caption ?? getExtension(msg?.document?.mime_type)}
                  {/* {getExtension(msg?.document?.mime_type)} */}
                </p>
              </div>
            </div>
          </div>
        );
      case "contacts":
        return Array.isArray(msg.contacts) ? (
          msg.contacts?.map((cm, ci) => (
            <div
              key={ci}
              className="flex justify-between item-center w-full p-2 py-2 pr-14 gap-4"
            >
              <i className="fa-solid fa-user text-gray-500 text-[24px] text-center pt-2"></i>
              <div>
                <p className="w-full h-auto text-gray-900 text-[16px] sm:text-sm break-words whitespace-pre-wrap">
                  {cm.name?.formatted_name}
                </p>
                <p className="w-full h-auto text-gray-900 text-[16px] sm:text-sm break-words whitespace-pre-wrap">
                  {Array.isArray(cm?.phones)
                    ? cm?.phones[0]?.phone
                    : cm?.phones?.phone}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="flex justify-between w-full p-2 py-2 pr-14 gap-4">
            <i className="fa-solid fa-user text-gray-500 text-[24px] text-center pt-2"></i>
            <div>
              <p className="w-full h-auto text-gray-900 text-[16px] sm:text-sm break-words whitespace-pre-wrap">
                {msg.contacts?.name?.formatted_name}
              </p>
              <p className="w-full h-auto text-gray-900 text-[16px] sm:text-sm break-words whitespace-pre-wrap">
                {Array.isArray(msg.contacts?.phones)
                  ? msg.contacts?.phones[0]?.phone
                  : msg.contacts?.phones?.phone}
              </p>
            </div>
          </div>
        );
      case "location":
        return (
          <div className="relative w-full mx-auto h-[120px]">
            <img
              className={"absolute h-full w-full rounded-md z-0"}
              src={latLngToTile(
                parseFloat(msg?.location?.latitude),
                parseFloat(msg?.location?.longitude),
                13
              )}
            />
            <div
              className="relative cursor-pointer w-full mx-auto z-1"
              onClick={() => {
                window.open(
                  `https://www.google.com/maps?q=${msg?.location?.latitude},${msg?.location?.longitude}&z=17&hl=en`
                );
              }}
            >
              <div className="absolute hover:bg-gray-50 bg-opacity-40 hover:bg-opacity-40 rounded-md h-[120px] w-full flex justify-center items-center">
                <i className="fa-solid fa-location-dot text-theme text-[30px]"></i>
              </div>
            </div>
          </div>
        );
      case "template":
        return (
          <div className="relative">
            <TemplatePreview
              template={template}
              carouselTemplate={carouselTemplate}
              timezone={wabaTimezone}
              waba={globalReducer.waba}
              width="w-full"
              isHideTime={true}
              message={message}
              selectedContact={selectedContact}
              isOpenWebLiveChat={isOpenWebLiveChat}
            />
          </div>
        );
      case "interactive":
        if (isReplied) {
          return (
            <div className="flex justify-between w-full">
              <p className="w-full h-auto sm:text-sm break-words whitespace-pre-wrap">
                {msg?.interactive?.button_reply?.title ?? msg?.interactive?.list_reply?.title}
              </p>
            </div>);
        } else {
          return (
            <div className="relative">
              {getInteractiveHeader(msg?.interactive?.header)}
              <div className="flex justify-between w-full">
                <p className="w-full h-auto sm:text-sm break-words whitespace-pre-wrap">
                  {msg?.interactive?.body?.text}
                </p>
              </div>
              <div className="flex justify-between w-full">
                <p className="w-full h-auto text-[#788082] text-xs break-words whitespace-pre-wrap">
                  {msg?.interactive?.footer?.text}
                </p>
              </div>
              <div className="flex flex-col px-2">
                {msg?.interactive?.action?.buttons?.map((btn, index) => (
                  <button key={index} type="button" className="min-w-[76px] mt-2 text-center px-[16px] py-[6px] text-gray-600 font-medium text-[14px] bg-gray-300 transition-all ease-in-out rounded cursor-pointer hover:bg-gray-400"
                    onClick={() => sendButtonReplyMessage(btn, msg?.type, false)} >{btn?.reply?.title}</button>
                ))}
                {msg?.interactive?.action?.sections?.length > 0 && <>
                  <div className="flex justify-center gap-4 text-[14px] bg-gray-300 transition-all ease-in-out rounded cursor-pointer hover:bg-gray-400 px-2 py-1 mt-2"
                    onClick={() => setInteractiveBtnShow(true)}>
                    <i className="fa-solid fa-list pt-1"></i>
                    <label>{msg?.interactive?.action?.button}</label>
                  </div>
                </>}
              </div>
            </div>
          );
        }
      case "button":
        return (
          <div className="flex justify-between w-full">
            <p className="w-full sm:text-sm break-words whitespace-pre-wrap">
              {msg?.button?.text}
            </p>
          </div>);
    }
  };

  const getInteractiveHeader = (msgObj) => {
    switch (msgObj?.type) {
      case "text":
        return (
          <p className="w-full h-auto font-semibold text-xs break-words whitespace-pre-wrap">
            {msgObj?.text}
          </p>
        );
      case "video":
        return (
          <div className="w-full mx-auto h-[140px]">
            {previewfile ? (
              <video
                className="object-fill rounded-md h-[140px] w-full mx-auto pb-5"
                controls
              >
                <source src={previewfile} type={msgObj?.video?.mime_type} />
              </video>
            ) : (
              <div className="relative cursor-pointer w-full mx-auto">
                {isDownLoading && (
                  <div className="flex justify-center item-center">
                    <div className="absolute pt-11">
                      <div className="w-9 h-9 rounded-full animate-spin border-2 border-solid border-theme border-t-transparent" />
                    </div>
                  </div>
                )}
                <div
                  onClick={() => msgObj?.video?.link ? onFileDownloadingFromUrl(msgObj?.video?.link) : onFileDownloading(msgObj?.video?.id)}
                  className="absolute bg-gray-500 bg-opacity-40 rounded-md h-[120px] w-full flex justify-center items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="text-white w-9 h-9"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        );
      case "image":
        return (
          <div className="relative w-full">
            <div className="h-auto w-full mx-auto pb-5">
              <div className="h-[120px] min-w-[200px]">
                {previewfile ? (
                  <a href={previewfile} download>
                    <img
                      className={"h-full w-full object-contain rounded-md "}
                      src={previewfile}
                    />
                  </a>
                ) : (
                  <div className="flex justify-center pt-10">
                    <i className="fa-solid fa-image text-[24px] text-gray-400"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case "document":
        return (
          <div className="w-full mx-auto h-[140px]">
            <div
              className="w-full flex flex-col items-center rounded-md px-4 py-6"
              onClick={() => msgObj?.document?.id ? onFileDocumentDownloading(msgObj?.document?.id) : onFileDocumentDownloadingFullUrl(msgObj?.document?.link)}
            >
              {isDownLoading && (
                <div className="flex justify-center item-center">
                  <div className="absolute pt-11">
                    <div className="w-9 h-9 rounded-full animate-spin border-2 border-solid border-theme border-t-transparent" />
                  </div>
                </div>
              )}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                className="w-9 h-9 text-gray-400 hover:text-theme"
              >
                <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
              </svg>
              <div className="mt-2 w-full">
                <p className="text-xs text-center font-medium leading-5 text-gray-600 truncate">
                  {msgObj?.document?.caption ?? getExtension(msgObj?.document?.mime_type)}
                </p>
              </div>
            </div>
          </div>
        );
      default:
        return "";
    }
  }

  const sendButtonReplyMessage = (btnMsg, type, listReply = false) => {
    if (selectedContact?.contact?.createdForm === "WEBLIVECHAT" && isOpenWebLiveChat && !isReply) {
      const messageObj = {
        "context": { "from": selectedContact?.contact?.whatsappNumber, "id": message?.referenceId },
        "from": selectedContact?.contact?.whatsappNumber, "id": "reply." + uuidv4(),
        "timestamp": new Date().getMilliseconds(),
        "type": type,
      }
      if (listReply) {
        messageObj.interactive = {
          "type": "list_reply",
          "list_reply": btnMsg
        };
      } else {
        messageObj.interactive = {
          "type": "button_reply",
          "button_reply":
          {
            "id": btnMsg?.reply?.id,
            "title": btnMsg?.reply?.title
          }
        };
      }
      setInteractiveBtnShow(false);
      dispatch(sendLiveChatMessage(
        {
          tenantId: globalReducer.loginInfo?.tenantId,
          contact: selectedContact?.contact,
          contactId: selectedContact?.contact?.id,
          tenantWabaId: globalReducer.waba?.id,
          messageType: "LIVE_CHAT",
          type: type,
          source: selectedContact?.contact?.createdForm,
          isReceived: true,
          reply: true,
          message: messageObj,
          messageText: JSON.stringify([messageObj]),
        },
        (a) => { setSelectedButton({}); setInteractiveBtnShow(false); },
        false
      ));
    }
  };

  return (
    <div className="relative">
      {message?.messageStatus?.toLowerCase() === "failed" && <><div className='top-0 left-0 z-10 font-bold leading-none flex items-center'>
        <span className='text-[10px] text-theme'>{message.remarks}</span>
      </div>
        <div className='absolute right-0 z-10'>
          <i className="fa-solid fa-triangle-exclamation text-[14px] text-theme"></i>
        </div></>}
      {message?.source === "CHATBOT" && !isReply && <i className="fa-brands fa-rocketchat text-gray-500"></i>}
      <div className={`overflow-hidden flex gap-2 justify-between relative ${isReply || message?.type === "sticker" ? "" : `rounded-xl ${message?.justifyEnd ? "bg-[#dcfce7]" : "bg-[#f7f8fc]"}`} w-full pt-[4px] pr-[12px] pb-[8px] pl-[8px]`}>
        <div className='text-wrap min-w-[140px]'>{getMessage()}</div>
        {!isReply &&
          <p className="p-[0px] text-[10px] text-gray-500 flex items-end absolute bottom-[0px] right-[8px] z-[9]">
            {moment.utc(message?.createdAt).tz(wabaTimezone).format('hh:mm a')}
          </p>}
        {/* {reaction &&
          <span className="absolute bottom-[0px] right-[60px] z-[9] rounded-lg">{reaction?.emoji}</span>
        } */}
      </div>
      <div>
        {interactiveBtnShow && !isReply && <div ref={interactiveBtn} className={`p-[16px] bg-white rounded-[4px] text-[14px] mt-4 dropdown-shadow absolute w-[290px] min-h-[300px] bottom-[0px] z-[99] ${message?.justifyEnd ? 'right-40' : 'left-40'}`}>
          {message?.messageText?.interactive?.action?.sections?.map((section, index) => (
            <div key={index} className="">
              <p className="text-gray-600 font-medium text-[14px] bg-gray-200 px-2 py-1 rounded-md">{section?.title}</p>
              {section?.rows?.map((row, rowIndex) => (
                <div className={`mx-2 px-1 mt-1 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-300 ${selectedButton?.id === row?.id ? 'bg-gray-300' : ''}`} key={rowIndex} onClick={() => setSelectedButton(row)}>
                  <p className="text-gray-500 text-[12px] font-semibold text-xs">{row?.title}</p>
                  <p className="text-gray-400 text-[12px]">{row?.description}</p>
                </div>
              ))}
            </div>
          ))}
          {isOpenWebLiveChat && <button type="button" className={`w-full mt-2 text-center px-[16px] py-[6px] text-gray-600 font-medium text-[14px] ${selectedButton?.id ? "bg-gray-300" : "bg-gray-100"} transition-all ease-in-out rounded cursor-pointer hover:bg-gray-400`}
            onClick={() => sendButtonReplyMessage(selectedButton, message?.type, true)} >Send</button>}
        </div>}
      </div>
    </div>
  );
}

export default WhatsappMessage;
